import { useEffect, useRef, useState } from 'react';

import type { FrequencyValue } from '@/constants/Frequency';
import type { CycleEvaluationGroup } from '@/types/cycle-evaluation/CycleEvaluationGroup';

/** Undefined when the group carries none, so the guard refuses rather than invents; read ONCE, else a refetch reverts a second pick. */
const useDeadlineRecurrence = (group?: CycleEvaluationGroup) => {
    const [frequency, setFrequency] = useState<FrequencyValue>();

    const hydratedRef = useRef(false);

    useEffect(() => {
        if (hydratedRef.current || !group) {
            return;
        }

        hydratedRef.current = true;

        if (group.frequency) {
            setFrequency(group.frequency);
        }
    }, [group]);

    return { frequency, setFrequency };
};

export { useDeadlineRecurrence };
